import React, { Fragment } from "react";
import { HorizontalToolbar, Button, ToolIcon, Divider, Menu } from "@theorgchartdev/storybook";
import UndoRedoComposite from "./UndoRedoComposite/UndoRedoComposite";
import EditMenu from "./EditMenu/EditMenu";
import ZoomCanvasMenu from "./ZoomCanvasMenu/ZoomCanvasMenu";
import * as StateLib from "@/Utils/StateLib";
import { ChartSettingsSectionRoutes } from "@/providers/NavigationProvider";
import { useNavigate } from "react-router-dom";
import { Globals } from "@coreapp/CoreApp/Globals";
import { IsBackgroundFile } from "@coreapp/utils/IsBackgroundFile";
import { appstr } from "@coreapp/utils/appstr";

const BuildChartOptions = clickHandler => {
  const WSMgr = StateLib.GetWSMgr();
  let chartsList = WSMgr.GetAllowedCharts();
  let chartOptions = [];
  for (let chart of chartsList) {
    let chartOption = {};
    chartOption.label = chart["name"];
    chartOption.value = chart["ID"];
    chartOption.clickHandler = clickHandler;
    chartOptions.push(chartOption);
  }
  return chartOptions;
};

const MainToolbarBackgroundMode = () => {
  const navigate = useNavigate();
  const WSMgr = StateLib.GetWSMgr();
  const dividerClass = "ocn-toolbar-horizontal-divider";

  const wsMgr = StateLib.GetWSMgr();
  const currentFilename = wsMgr?.GetFileName(true);
  const isBackground = currentFilename ? IsBackgroundFile(currentFilename) : false;

  const backgroundEditMode = Globals._uiConfig.InBackgroundEditorMode() && isBackground;
  const inChartOrBackgroundEditMode = backgroundEditMode || Globals._uiConfig.InWorkbenchEditMode();

  var masterChartList = WSMgr.GetAllowedCharts();
  var masterCount = masterChartList ? masterChartList.length : 0;

  var chartID = null;
  var curDoc = WSMgr.GetDoc();
  if (curDoc) chartID = curDoc.GetChartID() ?? "0";

  const handleSingleChartSyncFields = () => {
    var masterChartList = WSMgr.GetAllowedCharts();
    WSMgr.DoReloadMasterChartFields(WSMgr, masterChartList[0]["chartID"]);
  };

  const reloadChartSyncFields = target => {
    WSMgr.DoReloadMasterChartFields(WSMgr, target.value);
  };

  const linkToChart = () => {
    const route = `/settings/chart/${chartID}/${ChartSettingsSectionRoutes.Presentation}`;
    navigate(route);
  };

  let tooltipProps = {
    message: appstr("Use fields from a base chart within this background")
  };

  let menuTrigger = (
    <Button
      dataTestId="background-editor-toolbar-fields-menu-trigger-btn"
      tooltipProps={tooltipProps}
      modifier={"secondary"}
    >
      Fields
    </Button>
  );

  const leftContent = (
    <Fragment>
      {backgroundEditMode && isBackground && (
        <Fragment>
          {masterCount === 1 ? (
            <Button
              dataTestId="background-editor-toolbar-fields-btn"
              tooltipProps={tooltipProps}
              modifier={"secondary"}
              onClick={handleSingleChartSyncFields}
            >
              Fields
            </Button>
          ) : (
            <Menu
              dataTestId="background-editor-toolbar-fields-menu"
              trigger={menuTrigger}
              value={chartID}
              listWidth={"medium"}
              listHeader={{
                label: appstr("Import fields from")
              }}
              options={BuildChartOptions(reloadChartSyncFields)}
            />
          )}
          <div className={dividerClass}>
            <Divider vertical={true} />
          </div>
          <ToolIcon
            dataTestId="background-editor-toolbar-select-charts-btn"
            name={"gear"}
            tooltipProps={{
              message: appstr("Select which charts should use this background by default")
            }}
            onClick={linkToChart}
          />
        </Fragment>
      )}
      <ZoomCanvasMenu />
    </Fragment>
  );

  const rightContent = (
    <Fragment>
      {inChartOrBackgroundEditMode && <UndoRedoComposite />}
      <EditMenu inEditMode={inChartOrBackgroundEditMode} />
    </Fragment>
  );

  return <HorizontalToolbar leftContent={leftContent} rightContent={rightContent} size={"large"} />;
};

export default MainToolbarBackgroundMode;
